import axios from "axios";
import { store } from "../app/store";

export const saveStoreData  = () => {
  axios.post(process.env.REACT_APP_BACKEND_API_URL + "/api/v1/front_state", {data: store.getState()});
}
